import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FirebaseService } from '../../service/firebase.service';

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrls: ['./userlist.component.scss']
})
export class UserlistComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<UserlistComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public _firebase: FirebaseService) { }
  userlist: any;
  selectedUser: any;

  ngOnInit(): void {


    this._firebase.getSubUserList().then(d => {
      this.userlist = d;

 //     console.log(this.userlist)
    })

  }


  setSelected(item) {
    this.selectedUser = item
  }


  onNoClick() {
    this.dialogRef.close();
  }
}
